import { Box, IconButton, Typography, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material'
import { useState } from 'react';
import { ReactComponent as SmartPhone } from '../../../static/icons/smartPhone.svg';
import { fwpSync } from '../../../services/api-service'; // Assuming this is the correct path
import { showSuccessNotification, showErrorNotification } from '../../../components/admin/common/NotiService'; // Assuming this is the correct path
import { LoadingButton } from '@mui/lab';
import { checkRoles } from '../../../utils/util';

export default function FwpSync() {
    const [openDialog, setOpenDialog] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleConfirmSync = async () => {
        try {
            setLoading(true);
            const response = await fwpSync();
            if (response === "success") {
                showSuccessNotification("FWP Sync initiated successfully.");
            } else {
                showErrorNotification("FWP Sync failed. Please try again.");
            }
        } catch (error) {
            console.error("FWP Sync failed", error);
            showErrorNotification("FWP Sync failed. Please try again.");
        } finally {
            handleCloseDialog();
            setLoading(false);
        }
    };


    return (checkRoles("ROLE_ADMIN")) ? (
        <>
            <Box sx={{
                display: 'flex', width: '757px', background: 'white', borderRadius: '8px', justifyItems: 'center', alignContent: 'space-between', mt: '25px'
            }}>
                <Typography className='admin-settings-text-font' flexGrow={1} fontSize="14px">
                    FWP Sync
                </Typography>
                <IconButton
                    onClick={handleOpenDialog}
                    sx={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        mt: "5px",
                        mr: 2
                    }}
                >
                    <SmartPhone />
                </IconButton>
            </Box>

            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                aria-labelledby="fwp-sync-dialog-title"
                aria-describedby="fwp-sync-dialog-description"
                PaperProps={{
                    sx: {
                        borderRadius: "8px",
                        width: "400px"
                    }
                }}
            >
                <DialogTitle sx={{ fontSize: "18px", fontWeight: "400", color: "#212121" }} id="fwp-sync-dialog-title">Confirm FWP Sync</DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ fontSize: "14px", fontWeight: "400", color: "#212121" }} id="fwp-sync-dialog-description">
                        This will Sync the FWP Number details from Central to Local DB.
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ gap: "16px" }}>
                    <Button onClick={handleCloseDialog} color="primary" variant='outlined' sx={{ borderRadius: "8px" }}>
                        Cancel
                    </Button>
                    <LoadingButton sx={{ borderRadius: "8px" }} loading={loading} onClick={handleConfirmSync} color="primary" autoFocus variant='contained'>
                        Continue
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    ) : null
}
